import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { User } from 'src/app/front-user/shared/models/user.model';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { RefundMeasSecondReviewerDecision, FormMode, Languages, ServiceStatus } from 'src/app/shared/models/enums.model';
import { ReleaseRefundRequestDTO, ReleaseRestudyAdminDTO } from 'src/app/shared/models/long-haul.model';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { LongHaulService } from 'src/app/shared/services/long-haul.service';

@Component({
  selector: 'app-Restudy-measurement-Manager',
  templateUrl: './Restudy-measurement-Manager.component.html'
})
export class RestudyMeasurementManagerComponent {
  submitted = false;
  loading = false;
  showRequest: boolean = false;
  isErrorMessage: boolean = false;
  lockTaskErrorMessage: boolean = false;
  refundRequestObj: ReleaseRefundRequestDTO = new ReleaseRefundRequestDTO();
  refundAdminObj: ReleaseRestudyAdminDTO = new ReleaseRestudyAdminDTO();
  decision = RefundMeasSecondReviewerDecision;
  decisionKeys = Object.keys(this.decision);
  displayedLang: string;
  decisionValue: number;
  public FormMode: any = FormMode;
  public formMode: any = FormMode.Add;
  baseRequestId: string = '';
  user: User = new User();
  restudyManagerForm: FormGroup;
  responseObj: ResponseObject = new ResponseObject();
  requestStatus: number;
  @Input() public isShow: boolean = true;
  isLoaded: boolean = false;
  ListOfAdmins: [] = [];
  adminsDropdownSettings = {};
  //selectedEmails: [] = [];

  constructor(private formBuilder: FormBuilder,
    private globalSrv: GlobalServices,
    private alertService: AlertService,
    private longhaulserv: LongHaulService) {
    this.decisionKeys = this.decisionKeys.slice(this.decisionKeys.length / 2);
    this.displayedLang = this.globalSrv.getLanguage() == Languages.Arabic ? 'NameAR' : 'NameEN';
    if (history.state.data && history.state.data.requestId) {
      this.baseRequestId = history.state.data.requestId;
      this.getRequest();
    } else {
      window.history.back();
    }
    this.user = this.globalSrv.user;
    this.adminsDropdownSettings = {
      singleSelection: false,
      idField: 'Email',
      textField: 'Username',
      selectAllText: 'Select All',
      unSelectAllText:  'UnSelect All',
      allowSearchFilter: true,
      enableCheckAll: true
    };
  }
  ngOnInit() {
    this.buildForm(null);
  }

  buildForm(decision) {
    this.restudyManagerForm = this.formBuilder.group({
      Decision: ['', [Validators.required]],
    });
    if (decision == RefundMeasSecondReviewerDecision.MeasSecondReviewer_Approve) {
      this.restudyManagerForm = this.formBuilder.group({
        Decision: ['', [Validators.required]],
        //Admins: ['',[Validators.required]]
      });
    }
    else if (decision == RefundMeasSecondReviewerDecision.MeasSecondReviewer_MoreInformation) {
      this.restudyManagerForm = this.formBuilder.group({
        Decision: ['', [Validators.required]],
        MoreInformation: ['', [Validators.required]],
      });
    }
  }
  get form() {
    return this.restudyManagerForm.controls;
  }

  changeDecision(value) {
    this.buildForm(value);
    this.restudyManagerForm.patchValue({
      Decision: value
    });
    this.decisionValue = value;
    /*if(this.decisionValue == RefundMeasSecondReviewerDecision.MeasSecondReviewer_Approve){
      this.getNextStepUsers();
    }*/
  }

  getRequest() {
    this.longhaulserv.GetRestudyRequestById(this.baseRequestId).subscribe(
      (resObj: ResponseObject) => {
        this.responseObj = resObj;
        if (this.responseObj.Success) {
          this.refundRequestObj = this.responseObj.Data;
          this.requestStatus = this.refundRequestObj.BaseRequest.StatusId;
          this.isLoaded = true;
          if (history.state.data && history.state.data.isCompleted) {
            this.decisionValue = this.refundRequestObj.MeasReviewer2Decision;
            if (this.refundRequestObj.MeasReviewer2Decision == RefundMeasSecondReviewerDecision.MeasSecondReviewer_MoreInformation) {
              this.buildForm(this.decisionValue);
              this.restudyManagerForm.patchValue({
                Decision: this.decisionValue ,
                MoreInformation: this.refundRequestObj.MeasReviewer2Notes
              });
            }
            else {
              this.buildForm(this.decisionValue);
              this.restudyManagerForm.patchValue({
                Decision: this.decisionValue,
              });
            }
            this.formMode = FormMode.Readonly;
            this.restudyManagerForm.disable();
          }
          else if(this.requestStatus == ServiceStatus.Restudy_PendingManagerReviewer){
            this.formMode = FormMode.Add;
            this.restudyManagerForm.enable();
          }
          else{
            this.formMode = FormMode.Readonly;
            this.restudyManagerForm.disable();
            this.decisionValue = this.refundRequestObj.MeasReviewer2Decision;
            if (this.refundRequestObj.MeasReviewer2Decision == RefundMeasSecondReviewerDecision.MeasSecondReviewer_MoreInformation) {
              this.buildForm(this.decisionValue);
              this.restudyManagerForm.patchValue({
                Decision: this.decisionValue ,
                MoreInformation: this.refundRequestObj.MeasReviewer2Notes
              });
            }
            else {
              this.buildForm(this.decisionValue);
              this.restudyManagerForm.patchValue({
                Decision: this.decisionValue,
              });
            }

          }
        }
      }
    )
  }

 /* getNextStepUsers() {
    this.longhaulserv.GetNextStepUsers('SCAServices_RestudyEconomic').subscribe(
      (resObj: ResponseObject) => {
        if (resObj.Success) {
          this.ListOfAdmins = resObj.Data;
        }
      }
    )
  }*/

  /*nextUsersListChanged() {
    if (this.form.Admins && this.form.Admins.value != null) {
      this.selectedEmails = this.form.Admins.value.map(function (e) {
        return e.Email;
      });
    }
  }*/
  onSubmit() {

    this.submitted = true;
    // stop here if form is invalid
    if (this.restudyManagerForm.invalid) {
      return;
    }
    this.alertService.clear();
    this.globalSrv.isLoaderEnabled = true;
    this.loading = true;

    // this.refundRequestObj = this.restudyManagerForm.value;
    this.refundAdminObj.AdminEmail = this.user.UserName;
    this.refundAdminObj.Id = this.baseRequestId;
    this.refundAdminObj.MeasReviewer2Decision = this.decisionValue;
    if (this.decisionValue == RefundMeasSecondReviewerDecision.MeasSecondReviewer_Approve) {
      //this.refundAdminObj.WFNextUsers = this.selectedEmails;
    } else {
      this.refundAdminObj.MeasReviewer2Notes = this.restudyManagerForm.controls.MoreInformation.value;
    }

    this.longhaulserv.SubmitRestudyMeasManagerDecision(this.refundAdminObj)
      .subscribe(
        (data: ResponseObject) => {
          if (data.Success) {
            this.globalSrv.isLoaderEnabled = false;
            //this.alertService.success('Decision Submitted Successfully', false);
            this.restudyManagerForm.reset();
            this.loading = false;
            this.showRequest = true;
            this.isErrorMessage = false;
          }
          else if (data.ErrorMessages.find(e => e == "TaskCompletedByAnotherUser") != null) {
            this.lockTaskErrorMessage = true;
            this.showRequest = true;
            this.globalSrv.isLoaderEnabled = false;
          }
          else {
            this.globalSrv.isLoaderEnabled = false;
            this.showRequest = true;
            this.isErrorMessage = true;
            this.loading = false;
          }

        });
  }

}
